(() => {
  if (window.MotionFormsReady) return;
  window.MotionFormsReady = true;
  function focusResult(root = document) {
    if (window.Shopify?.designMode) return;
    const results = [...root.querySelectorAll('[data-form-result]')];
    const hash = window.location.hash.slice(1);
    const result = results.find(node => node.closest('form')?.id === hash) || results[0];
    if (!result || result.dataset.resultFocused || result.closest('[hidden]')) return;
    result.dataset.resultFocused = 'true';
    result.focus();
  }
  focusResult();
  document.addEventListener('shopify:section:load', event => focusResult(event.target));
})();
